Controller.$inject = [];

function Controller() {
    const self = this;
}

export function HuiSkeleton() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            width: '@',
            height: '@',
            shape: '@'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                    <div class="hui-skeleton" 
                             ng-class="[$huiCtrl.shape || 'rectangle']" 
                             ng-style="{ width: $huiCtrl.width + 'px',  height: $huiCtrl.height + 'px'}"></div>
                `;
        }
    }
}